const RELIVE_MEMORIES_BLOCK_DATA = {
  isDarkTheme: true,
  withoutRate: true,
  withMobileLine: true,
  titleList: [
    {
      id: 1,
      text: 'ready to order?',
      textMob: 'ready to order?',
      secondText: '',
      secondTextMob: '',
      isTextReverse: false,
      isTextReverseMob: false,
      isTextColumn: false,
      isTextColumnMob: false,
      isLeft: false,
      isLeftMob: false,
      isRight: false,
      isRightMob: false,
      color: '#fff',
      colorMob: '#ECC486',
      isTextWithLine: true,
      isTextWithLineMob: false,
      isSecondTextWithLine: false,
      isSecondTextWithLineMob: false,
      firstTextLines: [{
        id: 1,
        isLeftLine: true,
        isRightLine: false,
        isTopLine: false,
        isBottomLine: false,
        color: '#fff',
        isLineWithSquare: true,
        isLeftLineMob: true,
        isRightLineMob: false,
        isTopLineMob: false,
        isBottomLineMob: false,
        colorMob: '#fff',
        isLineWithSquareMob: false,
      },
      {
        id: 2,
        isLeftLine: false,
        isRightLine: true,
        isTopLine: false,
        isBottomLine: false,
        color: '#fff',
        isLineWithSquare: true,
        isLeftLineMob: false,
        isRightLineMob: true,
        isTopLineMob: false,
        isBottomLineMob: false,
        colorMob: '#fff',
        isLineWithSquareMob: true,
      }],
      secondTextLines: [],
    },
  ],
  leftButtonText: 'Place An Order Online',
  leftButtonTextMobile: 'Place An Order Online',
  leftButtonLink: '',
  rightButtonText: 'Talk To Our Team',
  rightButtonTextMobile: 'Talk To Our Team',
  rightButtonLink: '',
  reviewsCount: 2717,
};

export default RELIVE_MEMORIES_BLOCK_DATA;
